import { render } from "./MarkdownView.vue?vue&type=template&id=45a87f61&scoped=true"
import script from "./MarkdownView.vue?vue&type=script&lang=js"
export * from "./MarkdownView.vue?vue&type=script&lang=js"

import "./MarkdownView.vue?vue&type=style&index=0&id=45a87f61&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a87f61"]])

export default __exports__